__turbopack_context__.v({
  "highlight": "highlight-jobs-module__UsQuPW__highlight",
  "highlight_box": "highlight-jobs-module__UsQuPW__highlight_box",
  "highlight_company": "highlight-jobs-module__UsQuPW__highlight_company",
  "highlight_company_name": "highlight-jobs-module__UsQuPW__highlight_company_name",
  "highlight_data": "highlight-jobs-module__UsQuPW__highlight_data",
  "highlight_info": "highlight-jobs-module__UsQuPW__highlight_info",
  "highlight_list": "highlight-jobs-module__UsQuPW__highlight_list",
  "highlight_localization": "highlight-jobs-module__UsQuPW__highlight_localization",
  "highlight_responsibility": "highlight-jobs-module__UsQuPW__highlight_responsibility",
  "highlight_share": "highlight-jobs-module__UsQuPW__highlight_share",
  "highlight_text": "highlight-jobs-module__UsQuPW__highlight_text",
  "img_container": "highlight-jobs-module__UsQuPW__img_container",
  "super": "highlight-jobs-module__UsQuPW__super",
  "top": "highlight-jobs-module__UsQuPW__top",
});
